import React, { createContext, ReactNode, useEffect, useState } from 'react';

export type Indicator = 'fullScreen' | 'local' | 'custom';

export type DataFetchCtx = {
  isDataFetching: boolean;
  loadingMessage?: string;
  indicator?: Indicator;
  setDataFetchingInfo: (isFetching: boolean, message?: string, indicator?: Indicator) => void;
};

export const DataFetchContext = createContext<DataFetchCtx>({
  isDataFetching: false,
  setDataFetchingInfo: () => {},
});

export const DataFetchProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [isDataFetching, setIsDataFetching] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState<string>();
  const [indicator, setIndicatorId] = useState<Indicator>();
  const [activeRequests, setActiveRequests] = useState(0);

  const handleSetDataFetching = (_isDataFetching: boolean, message?: string, id?: Indicator) => {
    setLoadingMessage(message);
    setIndicatorId(id);
    setActiveRequests((prevCount) => (_isDataFetching ? prevCount + 1 : Math.max(prevCount - 1, 0)));
  };
  useEffect(() => {
    if (activeRequests > 0) {
      setIsDataFetching(true);
      const newTimeoutId = setTimeout(() => {
        setIsDataFetching(false);
        setActiveRequests(0);
      }, 30000);
      return () => clearTimeout(newTimeoutId);
    }
    setIsDataFetching(false);
    return () => {};
  }, [activeRequests]);
  return (
    <DataFetchContext.Provider
      value={{ isDataFetching, loadingMessage, indicator, setDataFetchingInfo: handleSetDataFetching }}
    >
      {children}
    </DataFetchContext.Provider>
  );
};

export const useDataFetch = (): DataFetchCtx => React.useContext(DataFetchContext);
